var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrolesson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.33,
    height: 84.33,
    viewBox: "-14.55 -1 84.33 84.33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.947 10.334H17.48c-5.32 0-7.98 0-10.013 1.035a9.5 9.5 0 00-4.152 4.152C2.28 17.553 2.28 20.213 2.28 25.533v32.934c0 5.32 0 6.314 1.035 8.346a9.5 9.5 0 004.152 4.152C9.5 72 12.16 72 17.48 72h20.267c5.32 0 7.98 0 10.013-1.035a9.5 9.5 0 004.151-4.152c1.036-2.032 1.036-3.026 1.036-8.346V28M40.28 45.166H14.947M40.28 57.833H14.947M21.28 32.5h-6.333",
    stroke: "currentColor",
    strokeWidth: 4.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.613 2l.737 1.991c.966 2.612 1.45 3.918 2.402 4.87.953.953 2.258 1.436 4.87 2.402l1.991.737-1.992.737c-2.611.966-3.916 1.45-4.869 2.402-.953.952-1.436 2.258-2.402 4.87L53.613 22l-.737-1.991c-.966-2.612-1.45-3.918-2.402-4.87-.952-.953-2.258-1.436-4.87-2.402L43.614 12l1.992-.737c2.611-.966 3.917-1.45 4.869-2.402.953-.952 1.436-2.258 2.402-4.87L53.613 2z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
export default SvgMicrolesson;